import React, { FC } from 'react';
import './UserForm.css';
import {
	FaUser,
	FaBriefcase,
	FaCalendarAlt,
	FaCity,
	FaPhone,
	FaEnvelope,
	InputField,
	SelectField,
	TextAreaField,
	FaUserLock,
	RequiredNote,
	SelectOptionType,
	DomainFormProps,
} from '@/Shared';
import { MultiValue } from 'react-select';

/**
 * =====================================================
 * Component: UserForm
 * =====================================================
 *
 *
 * Domain-specific form UI for User.
 * Mounted inside GenericDomainForm.
 *
 * Responsibilities:
 * - Render user fields
 * - Use data from formVM (options, values)
 *
 * No permissions, no loading, no orchestration logic here.
 *
 * Author: Samano CASTRE
 * Date: February 15, 2026
 */
const UserForm: FC<DomainFormProps> = ({
	domainFormHook,
	formRef,
	formikProps,

}) => {

	const { setFieldValue } = formikProps;
	const { entityFormVM } = domainFormHook;

	/**
	 * =====================================================
	 * Main Form Rendering
	 * =====================================================
	 *
	 * Fieldsets organize the form into logical sections for clarity.
	 */
	return (

		<div className="fieldset-wrapper">

			<fieldset>
				<legend>Civilité</legend>
				<InputField
					required
					label='Nom'
					icon={<FaUser />}
					name='person.lastname'
					placeholder="Saisir le nom de l'agent"
					autoComplete='name' />

				<InputField
					required
					label='Prénom'
					icon={<FaUser />}
					name='person.firstname'
					placeholder="Saisir le prénom de l'agent"
					autoComplete='given-name' />

				<SelectField
					required
					label='Civilité'
					icon={<FaUser />}
					name='person.civility'
					placeholder='Choisir une civilité'
					options={entityFormVM.civilityOptions}
					scrollParent={formRef.current}
				/>

				<InputField
					label='Date de naissance'
					icon={<FaCalendarAlt />}
					name='person.birthDate'
					type='date'
					autoComplete='bday' />
				<RequiredNote />
			</fieldset>
			<fieldset>
				<legend>Localisation</legend>
				<TextAreaField
					name="person.address"
					label='Adresse'
					placeholder={"Saisir l'adresse de l'agent"}
				/>
				<InputField
					label='Ville'
					icon={<FaCity />}
					name='person.city'
					placeholder="Saisir la ville de l'agent"
					autoComplete='address-level2'
				/>

				<InputField
					label='Pays'
					icon={<FaCity />}
					name='person.country'
					placeholder="Saisir le pays de l'agent"
					autoComplete='on' />
			</fieldset>
			<fieldset>
				<legend>Coordonnées</legend>

				<InputField
					required
					label='Téléphone 1'
					icon={<FaPhone />}
					name='person.phone1'
					placeholder="Saisir le téléphone de l'agent"
					type='tel'
					autoComplete='tel' />

				<InputField
					label='Téléphone 2'
					icon={<FaPhone />}
					name='person.phone2'
					placeholder="Saisir le téléphone de l'agent"
					type='tel'
					autoComplete='tel' />

				<InputField
					required
					label='Email'
					icon={<FaEnvelope />}
					name='person.email'
					placeholder="Saisir l'e-mail de l'agent"
					type='email'
					autoComplete='email' />
				<RequiredNote />
			</fieldset>
			<fieldset>
				<legend>Status</legend>
				<InputField
					label='Profession'
					icon={<FaBriefcase />}
					name='person.profession'
					placeholder="Saisir la profession de l'agent"
					autoComplete='on' />

				<InputField
					label='Embauché le'
					icon={<FaCalendarAlt />}
					name='hiredAt'
					placeholder="Date d'embauche"
					autoComplete='on'
					type='date' />

				<InputField
					label='Licencié le'
					icon={<FaCalendarAlt />}
					name='firedAt'
					placeholder="Date de licenciement"
					autoComplete='on'
					type='date' />

				<SelectField
					label='Manager'
					icon={<FaUser />}
					name='managerId'
					placeholder='Choisir un manager'
					options={entityFormVM.managerOptions}
					scrollParent={formRef.current}
				/>
			</fieldset>
			<fieldset className='width-50'>
				<legend>Fonctions & Rôle</legend>
				<SelectField
					label='Fonctions'
					icon={<FaUser />}
					name='positions'
					placeholder='Choisir une fonction'
					options={entityFormVM.positionOptions}
					scrollParent={formRef.current}
					isMulti
					onChange={
						(selectedOption) => {
							const positions = (selectedOption as MultiValue<SelectOptionType>).map(o => o.value);
							const selectedRole = entityFormVM.getHighestRole(positions);
							setFieldValue('role', selectedRole);
						}
					}
				/>

				<SelectField
					required
					label='Rôle'
					icon={<FaUserLock />}
					name='role'
					placeholder='Choisir un rôle'
					options={entityFormVM.roleOptions}
					scrollParent={formRef.current}
				/>

				<TextAreaField
					name="note"
					label='Note'
					placeholder={"Ecrire quelque chose..."}
				/>
				<RequiredNote />
			</fieldset>
		</div>

	);
}
export default UserForm;